// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3Uxwf","label":"Section_label__jyUrM","contentWrap":"Section_contentWrap__1ao3q","footer":"Section_footer__225T6","footerInner":"Section_footerInner__2Tw_o"};